import * as React from "react";
import Svg, { Path } from "react-native-svg";

function SvgComponent(props) {
  return (
    <Svg
      width={32}
      height={32}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <Path
        d="M0 13.09L13.09 0H32L0 32V13.09z"
        fill={props?.isActive ? "#00BA6E" : "rgba(0,0,0,0.5)"}
      />
      <Path
        d="M2.92 15.647l4.915-4.916.856.856-.731.731 3.982 3.982-1.042 1.043-2.061-2.061-1.23 1.229.203.202c.207.207.314.402.319.583 0 .177-.083.348-.25.514-.118.119-.28.212-.481.28a2.477 2.477 0 01-1.315.023 1.143 1.143 0 01-.49-.272.908.908 0 01-.257-.46c-.03-.176.068-.378.296-.606l2.349-2.349-1.066-1.066-3.142 3.143-.856-.856zm9.856-9.856l.855.856-.73.73 3.982 3.983-1.043 1.042-1.143-1.143c-.12.544-.412 1.05-.88 1.517-.352.352-.735.575-1.15.669-.42.088-.848.07-1.284-.055a4.272 4.272 0 01-1.283-.63c.239-.352.37-.66.397-.925.02-.27-.076-.511-.288-.724a1.18 1.18 0 00-.327-.233 1.634 1.634 0 00-.358-.125l-.94.942-.856-.856 5.048-5.048zm-1.105 6.3c.26.094.503.125.731.094.234-.037.451-.156.654-.358.44-.44.622-.996.544-1.665L11.858 8.42l-1.33 1.33c.17.047.332.109.482.187.15.078.298.189.443.334.472.472.545 1.079.218 1.82zm3.514-6.998l3.982 3.982-1.042 1.042-3.982-3.982-.623.622-.855-.855 2.403-2.404.856.856-.739.739z"
        fill="#fff"
      />
    </Svg>
  );
}

export default SvgComponent;
